import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Btn, Field, Input } from "../components/kit";
import { Logo } from "./Landing";

export default function Login() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/login", f);
      localStorage.removeItem("mapia_school");
      const me = await api.get("/auth/me");
      setUser(me.data);
      nav(data.platform_role === "super_admin" ? "/admin" : "/app");
    } catch (x) {
      setErr(errMsg(x));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hero-mesh grain relative hidden lg:flex flex-col justify-between p-12 text-white">
        <Logo light />
        <div className="relative z-10 max-w-md">
          <h1 className="font-heading text-4xl font-bold leading-tight">O mapa de merenda da sua escola, organizado do documento ao relatório.</h1>
          <p className="text-slate-300 mt-4">Estoque, cardápio, comensais e agricultura familiar em um só lugar.</p>
        </div>
        <p className="text-xs text-slate-400 relative z-10">WebFast Soluções Inteligentes</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5 rise" data-testid="login-form">
          <div className="lg:hidden"><Logo /></div>
          <div>
            <h2 className="font-heading text-3xl font-bold text-[#0B192C]">Acessar o MapIA</h2>
            <p className="text-sm text-slate-500 mt-1">Use o e-mail ou usuário cadastrado pela WebFast.</p>
          </div>
          <Field label="E-mail ou usuário">
            <Input data-testid="login-email-input" type="text" autoComplete="username" autoCapitalize="none" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
          </Field>
          <Field label="Senha">
            <Input data-testid="login-password-input" type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
          </Field>
          {err && <div data-testid="login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-3">{err}</div>}
          <Btn data-testid="login-submit-button" className="w-full py-2.5" disabled={busy}>{busy ? "Entrando…" : "Entrar"}</Btn>
          <p className="text-xs text-slate-500 flex justify-between gap-2"><Link to="/esqueci-senha" data-testid="forgot-password-link" className="text-[#FF6500] font-semibold">Esqueci minha senha</Link><Link to="/" className="text-slate-500 hover:text-[#FF6500]">Voltar ao site</Link></p>
        </form>
      </div>
    </div>
  );
}
